import React, { useState, useEffect, Fragment } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import TransmittalHardCopy from "./TransmittalHardcopy";
import TransmittalSoftCopy from "./TransmittalSoftCopy";
import TransmittalSelectRFI from "./TransmittalSelectRFI";
import Box from "@material-ui/core/Box";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Alert } from "../../Alert/Alert";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={1}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `submission-tab-${index}`,
    "aria-controls": `submission-tabpanel-${index}`,
  };
};

const TransmittalAttachments = (props) => {
  const [tabValue, setTabValue] = useState(0);
  const {
    submissionValue,
    setSubmissionValue,
    setSelectHardCopyDialogOpen,
    softCopyTemplate,
    setSoftCopyTemplate,
    isNew,
  } = props;
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertData, setAlertData] = useState({
    type: "",
    title: "",
    content: "",
  });
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  // Build Alert
  const buildAlert = (data) => {
    setAlertData({
      type: data.type,
      title: data.title,
      content: data.content,
    });
    setAlertOpen(true);
  };
  return (
    <Fragment>
      <Alert
        open={alertOpen}
        alertType={alertData.type}
        alertTitle={alertData.title}
        alertContent={alertData.content}
        handleClose={() => setAlertOpen(false)}
      />
      <div>
        <AppBar position="static" color="default">
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="transmittal document tabs "
            textColor="primary"
            indicatorColor="primary"
          >
            <Tab label="Select RFI Document" {...a11yProps(0)} />
            <Tab label="Import Attachment" {...a11yProps(1)} />
            <Tab label="Input Hard Copy" {...a11yProps(2)} />
          </Tabs>
        </AppBar>
        <TabPanel value={tabValue} index={0}>
          <TransmittalSelectRFI
            submissionValue={submissionValue}
            setSubmissionValue={setSubmissionValue}
            setSelectHardCopyDialogOpen={setSelectHardCopyDialogOpen}
            buildAlert={buildAlert}
          />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <TransmittalSoftCopy
            submissionValue={submissionValue}
            setSubmissionValue={setSubmissionValue}
            softCopyTemplate={softCopyTemplate}
            setSoftCopyTemplate={setSoftCopyTemplate}
            setSelectHardCopyDialogOpen={setSelectHardCopyDialogOpen}
            buildAlert={buildAlert}
            isNew={isNew}
          />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <TransmittalHardCopy
            submissionValue={submissionValue}
            setSubmissionValue={setSubmissionValue}
            setSelectHardCopyDialogOpen={setSelectHardCopyDialogOpen}
            buildAlert={buildAlert}
          />
        </TabPanel>
      </div>
    </Fragment>
  );
};

export default TransmittalAttachments;
